// extracted by mini-css-extract-plugin
export default {"pageContainer":"comingSoon_pageContainer__1QdWs"};